'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
require('./select-6c9d108c.js');
require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
var paper = require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
require('./tooltip-8d9d80ea.js');

var Container = styled__default(paper.Paper)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: ", ";\n  padding: 15px 16px 16px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top: ", "\n"], ["\n  display: flex;\n  flex-direction: ", ";\n  padding: 15px 16px 16px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-top: ",
    "\n"])), function (_a) {
    var alignment = _a.alignment;
    return alignment === 'right' && 'row-reverse';
}, function (_a) {
    var theme = _a.theme, hasBorder = _a.hasBorder;
    return "1px solid " + (hasBorder
        ? theme.colors.greys.adminGreyLight
        : theme.colors.universal.transparent);
});
var SmallFooter = function (_a) {
    var children = _a.children, rest = tslib_es6.__rest(_a, ["children"]);
    return (React__default.createElement(Container, tslib_es6.__assign({}, rest), children));
};
var templateObject_1;

exports.SmallFooter = SmallFooter;
